import Icon from '@amzn/awsui-components-core/icon';
import React from 'react';
import { WeatherSnapshot, TempUnit, toDisplayTemp } from 'src/services/WeatherService';
import { getWeatherIcon } from '../utils/welcome-banner-utils';

interface WeatherCardProps {
  weather: WeatherSnapshot;
  tempUnit: TempUnit;
  onTempUnitChange: (unit: TempUnit) => void;
  ariaLabel: string;
}

/**
 * @feature landing-page
 * @description Weather glanceable card — displays location, current temp, forecast,
 * high/low temps, and C/F toggle buttons.
 */
const WeatherCard: React.FC<WeatherCardProps> = ({ weather, tempUnit, onTempUnitChange, ariaLabel }) => {
  const handleTempChange = (unit: TempUnit) => {
    onTempUnitChange(unit);
    localStorage.setItem('finsuite-temp-unit', unit);
  };

  return (
    <div className="landing-welcome-banner__card" data-testid="weather-card">
      <a className="landing-welcome-banner__card-link" href={weather.weatherLink} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
        <Icon name="external" size="small" />
      </a>
      <span className="landing-welcome-banner__card-icon">{getWeatherIcon(weather.shortForecast, weather.isDaytime)}</span>
      <div className="landing-welcome-banner__card-content">
        <span className="landing-welcome-banner__card-label">{weather.location}</span>
        <span className="landing-welcome-banner__card-value">
          {toDisplayTemp(weather.temperature, tempUnit)}°{tempUnit}&nbsp; {weather.shortForecast}
        </span>
        <span className="landing-welcome-banner__card-sub">
          <button
            className={`landing-welcome-banner__temp-toggle ${tempUnit === 'C' ? 'landing-welcome-banner__temp-toggle--active' : ''}`}
            data-testid="temp-unit-c"
            onClick={() => handleTempChange('C')}
          >
            °C
          </button>
          {' / '}
          <button
            className={`landing-welcome-banner__temp-toggle ${tempUnit === 'F' ? 'landing-welcome-banner__temp-toggle--active' : ''}`}
            data-testid="temp-unit-f"
            onClick={() => handleTempChange('F')}
          >
            °F
          </button>
          {weather.dayHigh != null && (
            <>
              <span className="landing-welcome-banner__temp-divider" />
              <span className="landing-welcome-banner__temp-hl-label">H</span> {toDisplayTemp(weather.dayHigh!, tempUnit)}°{' '}
              <span className="landing-welcome-banner__temp-hl-label">L</span> {toDisplayTemp(weather.dayLow!, tempUnit)}°
            </>
          )}
        </span>
      </div>
    </div>
  );
};

export default WeatherCard;
